export const openMailTo = (email?: string): void => {
  if (email) window.open(`mailto:${email}`, "_blank", "noopener,noreferrer");
};

export const openTelTo = (phone?: string): void => {
  if (phone) window.location.href = `tel:${phone}`;
};
